const retryableStatusCodes = [503, 504];
const nonRetryableStatusCodes = [422];

export const clientError =
  "Sorry, your recent edits weren't saved. Try again later.";
export const serverError = 'Sorry, we have an issue on our end.';

interface Error {
  code?: 'ECONNABORTED' | '';
  response?: {
    status: number;
  };
}

// Can be deleted once files that use these consts are .ts files
export const AUTO_RETRY = 'AUTO_RETRY';
export const MANUAL_RETRY = 'MANUAL_RETRY';
export const NO_RETRY = 'NO_RETRY';

enum ErrorClassification {
  // eslint-disable-next-line @typescript-eslint/no-shadow
  AUTO_RETRY = 'AUTO_RETRY',
  // eslint-disable-next-line @typescript-eslint/no-shadow
  MANUAL_RETRY = 'MANUAL_RETRY',
  // eslint-disable-next-line @typescript-eslint/no-shadow
  NO_RETRY = 'NO_RETRY',
}

export const classifyError = ({
  code = '',
  response = { status: 0 },
}: Error = {}): ErrorClassification => {
  if (
    code === 'ECONNABORTED' ||
    retryableStatusCodes.indexOf(response.status) > -1
  ) {
    return ErrorClassification.AUTO_RETRY;
  }

  if (nonRetryableStatusCodes.indexOf(response.status) > -1) {
    return ErrorClassification.NO_RETRY;
  }

  return ErrorClassification.MANUAL_RETRY;
};

export const isRetryableByUser = (error: Error) =>
  classifyError(error) !== ErrorClassification.NO_RETRY;

export const getDisplayMessage = (error?: Error) =>
  classifyError(error) === ErrorClassification.NO_RETRY
    ? clientError
    : serverError;
